module.exports = __webpack_public_path__ + "static/media/lowerPart.fbbafd00.jpg";